// extracted by mini-css-extract-plugin
export default {"addToCartControl":"g1-z","giftCard":"h1-z","btnContainer":"i1-z","cartButton":"j1-z","disabled":"k1-z"};